// extracted by mini-css-extract-plugin
export default {"lightbox":"Article_lightbox__P6XDU","lightboxBackdrop":"Article_lightboxBackdrop__ExYMz","lightboxContent":"Article_lightboxContent__bu2lv","parchment":"Article_parchment__9+Kbq"};